import { render, staticRenderFns } from "./OrderBookResultRow.vue?vue&type=template&id=ff5bbcb0&scoped=true"
import script from "./OrderBookResultRow.vue?vue&type=script&lang=js"
export * from "./OrderBookResultRow.vue?vue&type=script&lang=js"
import style0 from "./OrderBookResultRow.vue?vue&type=style&index=0&id=ff5bbcb0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff5bbcb0",
  null
  
)

export default component.exports